import { ReactNode, Suspense } from 'react';
import { Button } from '@mercator-gcp/grout';
import { ErrorBoundary } from 'react-error-boundary';
import { Spinner } from 'components/elements/Spinner';
import { FlexColumn } from 'components/layout/FlexColumn/FlexColumn';

export const Loader = () => {
  const loadingSpinner = {
    height: '100%',
    width: '100%',
    alignItems: 'center',
    justifyContent: 'center',
  };

  return (
    <FlexColumn sx={loadingSpinner}>
      <Spinner />
    </FlexColumn>
  );
};

type Props = {
  children: ReactNode;
};

const ErrorFallback = ({ error, resetErrorBoundary }: any) => {
  return (
    <FlexColumn>
      <p>Something went wrong:</p>
      <pre>{error.message}</pre>
      <Button onClick={resetErrorBoundary}>Try again</Button>
    </FlexColumn>
  );
};

export const Loading = ({ children }: Props) => {
  return (
    <ErrorBoundary
      // eslint-disable-next-line react/no-unstable-nested-components
      fallbackRender={({ error, resetErrorBoundary }) => (
        <ErrorFallback error={error} resetErrorBoundary={resetErrorBoundary} />
      )}
    >
      <Suspense fallback={<Loader />}>{children}</Suspense>
    </ErrorBoundary>
  );
};
